import React, { useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import {
    Paper,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination
} from '@mui/material';
import axios from 'src/utils/axios';
import { Grid, IconButton, makeStyles } from '@material-ui/core';
import moment from 'moment';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Skeleton from '@mui/material/Skeleton';
import { useLocation } from 'react-router';

const useStyles = makeStyles({
    tableHead: {
        fontWeight: 'bold',
        borderLeft: '1px solid #ddd',
    },
    tableRow: {
        borderLeft: '1px solid #ddd',
    }
});

function IndividualInquiryReceipts() {
    const classes = useStyles();
    const history = useHistory();
    const location = useLocation();

    const { UYear, UPeriod, ModelCode, SerialNo } = useParams();

    const [generalData, setGeneralData] = React.useState([]);
    const [loading, setLoading] = React.useState(true);

    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(25);

    useEffect(() => {
        sendInformationsOfProduct();
    }, []);

    const sendInformationsOfProduct = () => {
        const data = {
            ModelCode: ModelCode,
            SerialNumber: Number(SerialNo),
            Year: Number(UYear),
            Month: Number(UPeriod)
        }

        axios.get(`GetReceiptsOfIndividualProduct/${data.ModelCode}/${data.SerialNumber}/${data.Year}/${data.Month}`)
            .then((response) => {
                var data = response.data;
                setGeneralData(data);
                setLoading(false);
            }).catch((error) => {
                setLoading(false);
            });
    }

    const handleRowClick = (ReceiptNumber) => {
        history.push(`/SarisQueries/ReceiptDetails/${ReceiptNumber}`);
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleGoBack = () => {
        const fullPath = location.pathname;
        const basePath = fullPath.split('/').slice(0, 2).join('/');
        // localStorage.setItem('previousPath', basePath || '/');
        // history.goBack();

        // Detay sayfasından dönüldüğünü belirtmek için previousPath'i güncelliyoruz.
        localStorage.setItem('previousPath', basePath || '/');
        history.goBack(); // Geri gitmek için useHistory hook'unu kullanıyoruz.

    }

    return (
        <Grid container spacing={2} style={{ overflow: 'auto', maxHeight: '90vh' }}>
            <Grid item xs={false} sm={false} md={2} />
            <Grid item xs={12} sm={12} md={8}>
                <Paper elevation={3} style={{ marginTop: '2rem', borderRadius: '1rem' }}>
                    <TableContainer component={Paper} style={{ borderRadius: '1rem' }}>
                        <Table size='small'>
                            <TableHead>
                                <TableRow style={{ backgroundColor: '#0033a0', color: '#fff' }}>
                                    <TableCell colSpan={6}>
                                        <Grid container alignItems="center">
                                            <Grid item xs={1}>
                                                <IconButton onClick={() => { handleGoBack(); }} style={{ color: '#fff' }}>
                                                    <ArrowBackIcon />
                                                </IconButton>
                                            </Grid>
                                            <Grid item xs={10}>
                                                <Typography variant="h5" align="center" style={{ color: '#fff' }}>
                                                    Fişler
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={1} />
                                        </Grid>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableHead>
                                <TableRow>
                                    <TableCell style={{ border: '1px solid #ddd' }}>Fiş Numarası</TableCell>
                                    <TableCell>Servis Kodu</TableCell>
                                    <TableCell style={{ border: '1px solid #ddd' }}>Hizmet</TableCell>
                                    <TableCell>Durum</TableCell>
                                    <TableCell style={{ border: '1px solid #ddd' }}>Tarih</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {loading ? (
                                    Array.from(new Array(3)).map((_, index) => (
                                        <TableRow key={index}>
                                            {Array.from(new Array(5)).map((_, cellIndex) => (
                                                <TableCell key={cellIndex} colSpan={1}>
                                                    <Skeleton animation="pulse" variant="text" width={150} />
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    ))
                                ) : (
                                    generalData.length > 0 && generalData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((item, index) => (
                                        <TableRow key={index}>
                                            <TableCell
                                                align='left'
                                                style={{
                                                    border: '1px solid #ddd'
                                                }}
                                            >
                                                <span
                                                    style={{
                                                        textDecoration: 'underline',
                                                        cursor: 'pointer',
                                                        color: '#4C3BCF'
                                                    }}
                                                    onClick={() => { handleRowClick(item.FIS_NO); }}
                                                >
                                                    {item.FIS_NO}
                                                </span>
                                            </TableCell>
                                            <TableCell>{item.SERVIS_KODU}</TableCell>
                                            <TableCell style={{ border: '1px solid #ddd' }}>{item.HIZMET}</TableCell>
                                            <TableCell>{item.DURUM}</TableCell>
                                            <TableCell style={{ border: '1px solid #ddd' }}>{moment(item.TARIH).format('DD-MM-YYYY HH:mm:ss')}</TableCell>
                                        </TableRow>
                                    ))
                                )}
                            </TableBody>
                        </Table>
                        <TablePagination
                            rowsPerPageOptions={[15, 25, 50, 100, 250]}
                            component="div"
                            count={generalData.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </TableContainer>
                </Paper>
            </Grid>
            <Grid item xs={false} sm={false} md={2} />
        </Grid>
    )
}

export default IndividualInquiryReceipts;